import { Component, OnDestroy } from '@angular/core'
import { Observable, of, Subscription, tap } from 'rxjs'
import { FormControlState, FormState, SetValueAction } from 'ngrx-forms'
import { Store } from '@ngrx/store'
import { CustomerInformationState, selectProfileState } from '../user-profile.state'
import { HttpService } from '@api/http.service'
import { ActivatedRoute, Router } from '@angular/router'
import { EditPage } from '../../../utils/services/can-deactivate-guard.service'
import { catchError } from 'rxjs/operators'
import { ErrorSnackBarComponent } from '../../../utils/components/error-snack-bar/error-snack-bar.component'
import { MatSnackBar } from '@angular/material/snack-bar'
import { CustomerInfoActions } from '../user-profile.actions'
import { Country } from '../../../utils/components/select-country/select-country.component'
import { INIT_COUNTRIES } from '../../../utils/components/select-country/i18n/de'

@Component({
  selector: 'cover-change-mobile',
  templateUrl: './change-mobile.component.html',
  styleUrls: ['./change-mobile.component.scss'],
})
export class ChangeMobileComponent extends EditPage implements OnDestroy {
  selectedCountryCallingCode: string = '' // callingCode
  changeMobileFormState$: Observable<FormState<string>>
  currentMobile$: Observable<string>
  userAddressState$: Observable<CustomerInformationState>
  userAddress: CustomerInformationState | undefined
  subscription: Subscription
  initCountries: Country[] = INIT_COUNTRIES

  constructor(
    private readonly store: Store,
    private readonly httpService: HttpService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly snackbar: MatSnackBar,
  ) {
    super()
    this.changeMobileFormState$ = this.store.select(selectProfileState.changeMobileControls)
    this.currentMobile$ = this.store.select(selectProfileState.mobileState)
    this.userAddressState$ = this.store.select(selectProfileState.customerInformationState)
    this.subscription = this.userAddressState$
      .pipe(
        tap(state => {
          this.userAddress = state
        }),
      )
      .subscribe()
  }

  onSubmit(formState: FormControlState<string>): void {
    if (this.userAddress) {
      this.pending = true
      this.httpService
        .updateAddress({
          customer_number: this.userAddress.customerNumber,
          customer_sub_number: this.userAddress.customerSubNumber,
          first_name: this.userAddress.firstName,
          last_name: this.userAddress.lastName,
          mobile: this.selectedCountryCallingCode + formState.value,
          phone_number: this.userAddress.phoneNumber,
          postal_code: this.userAddress.address.postalCode,
          street_2: this.userAddress.address.street2,
          street: this.userAddress.address.street,
          city: this.userAddress.address.city,
          country_code: this.userAddress.address.countryCode,
          email: this.userAddress.email,
          company: this.userAddress?.address.company,
          birthdate: this.userAddress?.birthdate,
        })
        .pipe(
          tap(response => {
            this.pending = false
            if (response.parameter === 'success') {
              this.formIsDirty = false
              this.router.navigate(['../'], { relativeTo: this.route }).then(() => {
                this.store.dispatch(CustomerInfoActions.customerInfoLoad({ payload: this.userAddress!.uuid }))
              })
            } else {
              this.snackbar.openFromComponent(ErrorSnackBarComponent, {
                duration: 5000,
                panelClass: ['error-snack-bar'],
              })
            }
          }),
          catchError(err => {
            this.pending = false
            this.snackbar.openFromComponent(ErrorSnackBarComponent, {
              duration: 5000,
              panelClass: ['error-snack-bar'],
            })
            return of(err)
          }),
        )
        .subscribe()
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  changeSelectedCountry(event: Country): void {
    if (!event) {
      this.selectedCountryCallingCode = ''
      return
    }
    if (this.selectedCountryCallingCode != event.callingCode && event.callingCode) {
      this.selectedCountryCallingCode = event.callingCode
      this.formIsDirty = true
    }
  }

  onPhoneNumberInput(event: Event, formState: FormControlState<string>): void {
    const inputElement = event.target as HTMLInputElement | null
    if (!inputElement) {
      return
    }

    const numericValue = inputElement.value.replace(/\D/g, '')
    if (inputElement.value !== numericValue) {
      inputElement.value = numericValue
    }

    this.store.dispatch(new SetValueAction(formState.id, numericValue))
  }
}
